"use strict";
exports.__esModule = true;
var FormatSpecifier = (function () {
    function FormatSpecifier(specifier) {
        var re = /^([<^>])?(\d+)?(,)?(\$)?(\.\d+)?(s)?(~)?((b\+?)|k|f[십백천만억조경해자양])?$/;
        var match = re.exec(specifier);
        if (!match) {
            throw new Error('Invalid format: ' + specifier);
        }
        this.align = match[1] || ">";
        this.width = match[2] && +match[2];
        this.comma = !!match[3];
        this.currency = !!match[4];
        this.precision = match[5] && +match[5].slice(1);
        this.spacing = !!match[6];
        this.trim = !!match[7];
        this.type = match[8] || "b";
    }
    return FormatSpecifier;
}());
exports["default"] = FormatSpecifier;
//# sourceMappingURL=specifiler.js.map